module.exports = __webpack_public_path__ + "media/img/girafales-268f80d2.png";